import * as HttpService from 'services/http.service';
import { CREATE_GUEST_USER } from 'services/url.service';

const createGuestUserAPI = () => HttpService.postWithoutAuth(CREATE_GUEST_USER);

export default createGuestUserAPI;
